export default __webpack_public_path__ + "static/floor1_image5-sp-5d7776822d5a2200f3186c36d09698b1.png";